/* Gallery filters + lightbox, ported from Gallery.dc.html (2026-08-10 handoff). */
(function () {
  var filters = document.querySelector('[data-mpg-filters]');
  if (!filters) return;

  var tiles = Array.prototype.slice.call(document.querySelectorAll('.mpg-tile'));
  var lightbox = document.querySelector('[data-mpg-lightbox]');
  var lightboxImg = document.querySelector('[data-mpg-lightbox-img]');

  filters.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mpg-filter]');
    if (!btn) return;
    var cat = btn.getAttribute('data-mpg-filter');
    filters.querySelectorAll('.mpg-filter').forEach(function (b) {
      b.classList.toggle('is-on', b === btn);
    });
    tiles.forEach(function (t) {
      t.hidden = cat !== 'ALL' && t.getAttribute('data-mpg-cat') !== cat;
    });
  });

  function openLightbox(src) {
    lightboxImg.style.backgroundImage = 'url("' + src + '")';
    lightbox.hidden = false;
  }
  function closeLightbox() {
    lightbox.hidden = true;
    lightboxImg.style.backgroundImage = 'none';
  }

  tiles.forEach(function (t) {
    t.addEventListener('click', function () { openLightbox(t.getAttribute('data-mpg-full')); });
    t.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLightbox(t.getAttribute('data-mpg-full')); }
    });
  });
  lightbox.addEventListener('click', closeLightbox);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !lightbox.hidden) closeLightbox();
  });
})();
